<template>
  <div class="item-two">
    <div class="nh-cont">
      <div>
        <el-tooltip :content="yrIndex[0].remark" placement="top" effect="light">
          <div>
            <h4>{{ yrIndex[0].abbr }}</h4>
            <p class="nh-current"><span>{{ abbr101.monAvg ||'--' }}</span><em> {{ yrIndex[0].unit }}</em></p>
            <p class="nh-difference"><span><i class="iconfont" :class="(abbr101.monAvg-yrIndex[0].standard)>0?'icon-cs-jt-xs-1-1':'icon-cs-jt-xx-1-1'"></i>{{ Math.abs(abbr101.monAvg-yrIndex[0].standard).toFixed(2) || '--' }}</span><em>{{ yrIndex[0].unit }}</em></p>
          </div>
        </el-tooltip>
      </div>
      <div>
        <el-tooltip :content="yrIndex[1].remark" placement="top" effect="light">
          <div>
            <h4>{{ yrIndex[1].abbr }}</h4>
            <p class="nh-current"><span>{{ abbr102.monAvg ||'--' }}</span><em> {{ yrIndex[1].unit }}</em></p>
            <p class="nh-difference"><span><i class="iconfont" :class="(abbr102.monAvg-yrIndex[1].standard)>0?'icon-cs-jt-xs-1-1':'icon-cs-jt-xx-1-1'"></i>{{ Math.abs(abbr102.monAvg-yrIndex[1].standard).toFixed(2) || '--' }}</span><em>{{ yrIndex[1].unit }}</em></p>
          </div>
        </el-tooltip>
      </div>
      <div>
        <h4>{{ yrIndex[2].abbr }}</h4>
        <p class="nh-current"><span>{{ abbr103.monAvg ||'--' }}{{ yrIndex[2].unit }}</span><em> 本月</em></p>
        <p class="nh-difference"><span>{{ abbr103.yearAvg ||'--' }}{{ yrIndex[2].unit }}</span><em>年度</em></p>
      </div>
    </div>
    <div class="floating-echart" id="floatingechart"></div>
  </div>
</template>

<script>
import countTo from 'vue-count-to';
export default {
  name: 'right-module-five',
  props: {
    dataRefresh: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  components:{
    countTo
  },
  data(){
    return {
      yrIndex:[{remark:'',abbr:''},{remark:'',abbr:''},{remark:'',abbr:''}],
      echartitle:[],
      echartdata1:[],
      echartdata2:[],
      echartdata3:[],
      echartdata4:[],
      abbr103:{monAvg:'',yearAvg:''},
      abbr102:{monAvg:'',yearAvg:''},
      abbr101:{monAvg:'',yearAvg:''},
    }
  },
  mounted () {
    this.getdata()
    this.dataRefresh.$ons('Refresh',()=>{
      this.getdata()
    })
  },
  methods: {
    getdata () {
      const url = '/api-portal/dm/dyeing';
      this.$api.get(url, {}, (response) => {
        let datas=response.data||''
        if(datas.code=='000000'){
          const dataall=datas.data
          this.yrIndex=dataall.yrIndex
          this.abbr101=dataall.abbr101
          this.abbr102=dataall.abbr102
          this.abbr103=dataall.abbr103
          this.echartitle=(dataall.yrDict).map(vals => {
            return vals.abbr
          })
          this.echartdata1=(dataall.abbr107).map(vals => {
            return vals.monAvg.toFixed(2)
          })
          this.echartdata2=(dataall.abbr104).map(vals => {
            return vals.monAvg.toFixed(2)
          })
          this.echartdata3=(dataall.abbr105).map(vals => {
            return vals.monAvg.toFixed(2)
          })
          this.echartdata4=(dataall.abbr106).map(vals => {
            return vals.monAvg.toFixed(2)
          })
          this.echartfloating()
        }
      });
    },
    echartfloating(){
      let $this=this
      const myEchartst = this.$echarts.init(document.getElementById('floatingechart'))
      let option = {
        title: {
          text: 'Stacked Line',
          show:false
        },
        tooltip: {
          trigger: 'axis',
        },
        legend: {
          show: false
        },
        toolbox: {
          show: false
        },
        grid: {
          left: '3%',
          top: '25%',
          right: '6%',
          bottom: '1%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          axisLabel: {
            color: '#C1D3F4'
          },
          data: $this.echartitle
        },
        yAxis: [{
          type: 'value',
          name:'浮动率',
          nameTextStyle:{
            color: '#C1D3F4'
          },
          axisLabel: {
            color: '#C1D3F4'
          },
          splitLine: {
            lineStyle: {
              color: '#1F4243'
            }
          }
        },{
          type: 'value',
          name:'成本比',
          nameTextStyle:{
            color: '#C1D3F4'
          },
          axisLabel: {
            color: '#C1D3F4'
          },
          splitLine:{
            show:false
          }
        }],
        series: [
          {
            name: '本月产值成本比',
            type: 'line',
            // stack: 'Total',
            yAxisIndex:1,
            smooth: true,
            markPoint: {
              data: [
                { type: 'max', name: 'Max' },
                { type: 'min', name: 'Min' }
              ]
            },
            data: $this.echartdata1
          },
          {
            name: '成品周浮动率',
            type: 'line',
            // stack: 'Total',
            yAxisIndex:0,
            smooth: true,
            data: $this.echartdata2
          },
          {
            name: '白坯周浮动率',
            type: 'line',
            // stack: 'Total',
            yAxisIndex:0,
            smooth: true,
            data: $this.echartdata3
          },
          {
            name: '能耗周浮动率',
            type: 'line',
            // stack: 'Total',
            yAxisIndex:0,
            smooth: true,
            data: $this.echartdata4
          }
        ]
      }
      this.loading7 = false
      myEchartst.setOption(option)
    }
  }
}
</script>
<style scoped>
.item-two {
  padding: 20px 20px 20px 14px;
  height: calc(100% - 20px);
}

.floating-echart{
  width: 100%;
  height: 204px;
  margin-top: -18px;
}

.nh-cont{
  width: 100%;
  margin-top: 16px;
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  justify-content: space-around;
}

.nh-cont>div{
  width: 101px;
  height: 54px;
  background: url("../../../assets/nh_bj.png") no-repeat center/100%;
  color: #fff;
  padding: 2px 4px;
  position: relative;
}

.nh-cont>div:after {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  background: #fff;
  border-radius: 2px;
  opacity: 0;
  animation: active3_4 13.4s cubic-bezier(.43,1,.52,1) infinite;
  content: " "
}

.nh-cont>div h4{
  font-size: 12px;
  transform:scale(0.85);
  margin-top: 2px;
  margin-left: 2px;
}

.nh-cont p{
  padding-left: 9px;
}

.nh-current span{
  font-size: 17px;
  color: #FFE63B;
  font-weight: bold;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}

.nh-current em{
  font-size: 12px;
  font-style: normal;
  color: #1FFEFE;
}

.nh-current{
  margin-top: 2px;
}

.nh-difference{
  margin-top: -3px;
}

.nh-difference span{
  font-size: 14px;
  color: #95DB77;
}

.nh-difference i{
  font-size: 12px;
}

.nh-difference em{
  font-size: 12px;
  display: inline-block;
  font-style: normal;
  color: #1EF0F1;
  transform:scale(0.8);
}

@keyframes active3_4 {
  65% {
    height: 0;
    opacity: .1
  }

  95% {
    height: 0;
    opacity: .5
  }

  to {
    height: 100%;
    opacity: 0
  }
}
</style>



// WEBPACK FOOTER //
// src/views/HomeManage/module/right-module-five.vue